import React from 'react';


import { CSSTransition } from 'react-transition-group';
import { range } from 'lodash-es';
import LoadingLogo from './common/LoadingLogo'

import TrainerCertificationDetails from './common/TrainerCertificationDetails'

import { history } from '../history'

import {
  AppleSvg,
  AndroidSvg,
} from '../constants/svgs'

import {
  GA_LABEL_CLICKED_APP_DOWNLOAD_LINK
} from '../constants/gaEventLabels'

import {
  subdomainUrls,
  recordLinkClickGA,
  ProductionCertificationUrl,
  ProductionCourseUrl,
  NeuroFitUniversalAppStoreLink,
  NeuroFitAppleAppStoreLink,
  NeuroFitGooglePlayStoreLink,
  CertificationCheckoutLink,
  recordPixelEventIfAvailable,
  recordLinkClickAndRedirect,
} from '../utils'

import Helmet from './common/Helmet'

class CertificationPage extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      headerBackgroundColor: "transparent",
      dropShadowColor: "transparent",
      headerBorderColor: "transparent",
      headerBackgroundBlur: "none",
      logoOutlineColor: "#EDEEF2"
    }
  }

  render() {

    const {
      safeAreaInsets,
      innerHeight,
      formFields,
      isNative,
      i18n,
      isIOSDevice,
      isAndroidDevice,
      isNasmPage
    } = this.props

    const {headerBorderColor, headerBackgroundColor, headerBackgroundBlur, logoOutlineColor, textShadow} = this.state
    
    const appDownloadUrl = isIOSDevice ? NeuroFitAppleAppStoreLink : (isAndroidDevice ? NeuroFitGooglePlayStoreLink : NeuroFitUniversalAppStoreLink)

    return (
      <div style={{height: innerHeight}}>
        <Helmet
          title={isNasmPage ? "Nervous System Course For Fitness Trainers & Gym Owners | NeuroFit" : "Nervous System Certification | Somatic Exercises | NeuroFit"}
          description={isNasmPage ? "A 3-Week Nervous System Course for fitness trainers and gym owners looking to accelerate personal & professional growth." : "A 3-Week Nervous System Certification for coaches & healers, covering nervous system regulation, somatic exercises, and trauma-informed witnessing."}
          href={isNasmPage ? ProductionCourseUrl : ProductionCertificationUrl}
        />
        <div style={{position: "fixed", left: 0, top: 0, height: innerHeight, overflow: "hidden", backgroundColor: "#FFFFFF"}}>
          <div style={{position: "fixed", top: 0, left: 0, right: 0, height: safeAreaInsets.top, backgroundColor: "#000000", zIndex: 2000}} />
          <div style={{position: "fixed", top: 0, left: 0, right: 0, borderBottom: `2px ${headerBorderColor} solid`, display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 5 + safeAreaInsets.top, paddingLeft: "min(40px, 7.5%)", paddingRight: "min(20px, 4%)", paddingBottom: 5, backgroundColor: headerBackgroundColor, zIndex: 1000, backdropFilter: headerBackgroundBlur, WebkitBackdropFilter: headerBackgroundBlur}}>
            <LoadingLogo
              show={true}
              hideAnimation={true}
              responsiveSize={"min(7vw, 35px)"}
              marginTop={"0px"}
              color={"#000000"}
              lineColor={logoOutlineColor}
              fontFamily={"Futura Book"}
              text={"NeuroFit"}
              dropShadowColor={logoOutlineColor}
              dropShadowMultiplier={5}
              showProgressionBar={false}
              onClick={() => history.push("/")}
            />
            <div style={{display: "flex", alignItems: "center"}}>
              <span
                onClick={() => {
                  if (isNasmPage) {
                    recordPixelEventIfAvailable("Lead")
                    recordLinkClickAndRedirect(GA_LABEL_CLICKED_APP_DOWNLOAD_LINK, appDownloadUrl)
                  } else {
                    window.location = "/"
                  }
                }}
                style={{cursor: "pointer", fontFamily: "Futura Medium", textShadow, fontSize: "min(4vw, 15px)", textTransform: "uppercase", color: "#000000", cursor: "pointer"}}
              >
                {isNasmPage ? "GET THE APP" : "Home"}
              </span>
            </div>
          </div>
          <TrainerCertificationDetails
            innerHeight={innerHeight}
            safeAreaInsets={safeAreaInsets}
            isNative={isNative}
            isNasmPage={isNasmPage}
            onContainerScroll={updatedState => {
              this.setState({...updatedState})
            }}
          />
        </div>
      </div>
    )
  }
}

export default CertificationPage;